import React from 'react';
import { App } from '@gin-betting/core';

import StreamLink from '../StreamLink';
import MarketsCount from '../MarketsCount';
import './promoFooter.scss';

interface Props {
    marketsCount: number | undefined;
    isWatchable: boolean;
    favoriteButton: JSX.Element;
    linkToMatch: string | null;
}

const PromoFooter: React.FC<Props> = ({
    marketsCount,
    isWatchable,
    favoriteButton,
    linkToMatch,
}) => {
    return (
        <div styleName="container">
            {favoriteButton}

            <MarketsCount
                marketsCount={marketsCount}
                linkToMatch={linkToMatch}
            />

            {isWatchable && <StreamLink linkToMatch={linkToMatch} />}
        </div>
    );
};

export default React.memo(PromoFooter);
